/** Timeout for API requests in milliseconds */
export const REQUEST_TIMEOUT = 5 * 60 * 1000
